import { render, staticRenderFns } from "./AdminPanelComponent.vue?vue&type=template&id=3a668ee7&"
import script from "./AdminPanelComponent.vue?vue&type=script&lang=js&"
export * from "./AdminPanelComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanelComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports